import { isUserFromWebView } from "@libs/utils/helpers/webviewComunication";
import { getBrand } from "@shared/services/brandConfig";

export default function getRedlineAppName() {
	const brand = getBrand();
	const typeName =
		isUserFromWebView() || window.isNativeApp ? "mobile-app" : "webapp";
	return `${brand}-${typeName}`;
}
